import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { transportAPIBase } from 'app/utilities/env';
import {
  TransportDeparture,
  TransportDestination,
} from 'features/booking/types/booking';

export const routesAPISlice = createApi({
  reducerPath: 'routesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${transportAPIBase}/routes`,
  }),
  endpoints: (build) => ({
    getLoadingOffices: build.query<TransportDeparture[], void>({
      query: () => '/loading-offices',
      transformResponse: (response: TServerResponse<TransportDeparture[]>) =>
        response.data,
    }),
    getDestinations: build.query<TransportDestination[], string>({
      query: (id) => `/destinations/${id}`,
      transformResponse: (response: TServerResponse<TransportDestination[]>) =>
        response.data,
    }),
  }),
});

export const { useGetLoadingOfficesQuery, useLazyGetDestinationsQuery } =
  routesAPISlice;
